import { FilterValue } from "../Filters/FilterValue";

export type PodBadgeStyle = {
  label: string;
  color: string;
  backgroundColor: string;
};

/** `name` = API identifier; `label` = UI text */
export const POD_PRINTING_TYPE_DEFINITIONS = [
  { name: "DTF", label: "DTF(Direct-to-film)", color: "#7C3AED", backgroundColor: "#EDE9FE" },
  { name: "DTG", label: "DTG(Direct-to-garment)", color: "#4338CA", backgroundColor: "#E0E7FF" },
  { name: "SCREEN_PRINT", label: "Screen print", color: "#BE185D", backgroundColor: "#FCE7F3" },
  { name: "UV_PRINT", label: "UV Print", color: "#0F766E", backgroundColor: "#CCFBF1" },
  { name: "LASER_PRINT", label: "Laser", color: "#B45309", backgroundColor: "#FEF9C3" },
  { name: "DEBOSSING", label: "Debossing", color: "#065F46", backgroundColor: "#D1FAE5" },
  { name: "EMBOSSING", label: "Embossing", color: "#9D174D", backgroundColor: "#FCE7F3" },
  { name: "SUBLIMATION", label: "Sublimation", color: "#1D4ED8", backgroundColor: "#DBEAFE" },
  { name: "EMBROIDERY", label: "Embroidery", color: "#C2410C", backgroundColor: "#FFEDD5" },
] as const;

export const POD_PRINTING_TYPE_OPTIONS: FilterValue[] =
  POD_PRINTING_TYPE_DEFINITIONS.map(item => ({
    id: item.name,
    value: item.label,
  }));

const findPrintingType = (value: string) => {
  const v = value.trim().toLowerCase();
  return POD_PRINTING_TYPE_DEFINITIONS.find(
    item =>
      item.name === value ||
      item.label.toLowerCase() === v ||
      item.name.toLowerCase() === v,
  );
};

export const getPodPrintingTypeLabel = (name: string): string =>
  findPrintingType(name)?.label ?? name.replace(/_/g, " ");

export const toPodPrintingTypeName = (value: string): string =>
  findPrintingType(value)?.name ?? value.trim();

export const getPodPrintingTypeBadgeStyle = (value?: string | null): PodBadgeStyle => {
  if (!value) {
    return { label: "—", color: "#6B7280", backgroundColor: "#F3F4F6" };
  }
  const item = findPrintingType(value);
  if (item) {
    return { label: item.label, color: item.color, backgroundColor: item.backgroundColor };
  }
  return { label: value.replace(/_/g, " "), color: "#374151", backgroundColor: "#F3F4F6" };
};
